import { css } from 'lit';

const stylesHMBDouble = css`
  :host {
    --container-width: 0px;
    --dynamic-1: calc(var(--container-width) * 1 / 582);
    --dynamic-3: calc(var(--container-width) * 3 / 582);
    --dynamic-4: calc(var(--container-width) * 4 / 582);
    --dynamic-6: calc(var(--container-width) * 6 / 582);
    --dynamic-8: calc(var(--container-width) * 8 / 582);
    --dynamic-12: calc(var(--container-width) * 12 / 582);
    --dynamic-15: calc(var(--container-width) * 15 / 582);
    --dynamic-16: calc(var(--container-width) * 16 / 582);
    --dynamic-20: calc(var(--container-width) * 20 / 582);
    --dynamic-32: calc(var(--container-width) * 32 / 582);
    --dynamic-73: calc(var(--container-width) * 73 / 582);
    --dynamic-92: calc(var(--container-width) * 92 / 582);
  }

  .hmb-double-wrapper {
    display: flex;
    gap: var(--dynamic-16);
  }

  .hmb-double-content-target {
    text-decoration: none;
    cursor: pointer;
    width: 100%;
    display: contents;
  }

  .hmb-double-container {
    max-width: 582px;
    width: 100%;
    aspect-ratio: 582 / 250;
    display: flex;
    border-radius: var(--dynamic-6);
    overflow: hidden;
  }

  .hmb-double-left-side,
  .hmb-double-right-side {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .hmb-double-left-side {
    width: 53.2%;
    aspect-ratio: 1 / 1;
    height: auto;
    overflow: hidden;
    position: relative;
  }

  .hmb-double-picture {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .hmb-double-right-side {
    width: 57.04%;
    position: relative;
    margin: 0 var(--dynamic-32);
    overflow: hidden;
  }

  .thb-double-left-container {
    display: flex;
    gap: var(--dynamic-16);
    padding: 2%;
    justify-content: center;
    align-items: center;
  }

  .hmb-double-left-img-container {
    display: flex;
    align-items: center;
    gap: var(--dynamic-12);
    justify-content: center;
  }

  .hmb-double-container-logo {
    width: 100%;
    display: flex;
    margin-bottom: var(--dynamic-20);
  }

  .hmb-double-position-logo {
    display: flex;
    align-items: center;
    gap: var(--dynamic-16 );
    justify-content: center;
  }

  .hmb-double-logo {
    width: var(--dynamic-92);
    height: var(--dynamic-73);
    border-radius: var(--dynamic-4);
    align-self: center;
    background-color: white;
    box-sizing: border-box;
    padding: var(--dynamic-1);
    object-fit: contain;
  }

  .hmb-double-texts-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .hmb-double-container-texts {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .hmb-double-text-volanta {
    font-size: var(--dynamic-12);
    line-height: 1.1;
    font-weight: 400;
    margin: 0 0 var(--dynamic-8) 0;
    letter-spacing: var(--dynamic-3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: uppercase;
  }

  #father-titles {
    display: flex;
    flex-direction: column;
    margin-bottom: var(--dynamic-16);
  }

  .hmb-double-text-title {
    font-size: var(--dynamic-20);
    line-height: 1.1;
    font-weight: 600;
  }

  .hmb-double-text-format {
    margin: 0;
    margin-bottom: var(--dynamic-6);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .hmb-double-text-format:last-of-type {
    margin-bottom: 0;
  }

  .hmb-double-cta{
    display: flex;
    align-items: center;
    gap: var(--dynamic-8);
  }

  .hmb-double-text-cta {
    font-size: var(--dynamic-16);
    line-height: 1.1;
    font-weight: 400;
    margin: 0;
  }

  .adn-cta-chevron {
    width: var(--dynamic-15);
    display: flex;
  }

  .hmb-double-text-legal {
    font-size: var(--dynamic-12);
    line-height: var(--dynamic-15);
    font-weight: 400;
    margin: 0;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -moz-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export default stylesHMBDouble;
